import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d7871dcc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "votes px-20 py-10" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "mb-20" }, "Проголосуй за лучшую идею", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "mb-20" }, "Голосуй и отслеживай популярность в твоём личном кабинете", -1))
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "text-center" }, "О сроках выхода серии сообщим дополнительно", -1))

import BaseButton from '@/components/Buttons/BaseButton.vue'
import IconBase from '@/components/Icons/IconBase.vue'
import BorderText from '@/components/BorderText.vue'
import { useAuthStore } from '@/stores/auth'
import { computed, onMounted, ref } from 'vue'
import axios from 'axios'
import { API_URL } from '@/helpers/globalVars'
import { useRoute } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectVotes',
  setup(__props) {

const route = useRoute()
const authStore = useAuthStore()
const isAuth = computed(() => authStore.isAuth)
const playListId = computed(() => route.params.id as string)
const votesList = ref([])
const isVotes = ref(false)

const getVotesList = async () => {
  await axios.get(`${API_URL}options/${playListId.value}`)
    .then((response) => {
      votesList.value = response.data
    }).catch((e) => {
      console.log('Votes error', e)
    })
}
const setVotes = async (optionId: string) => {
  if (isVotes.value) {
    return undefined
  }
  isVotes.value = optionId
  await axios.put(`${API_URL}options/${playListId.value}/${optionId}`)
    .catch((error) => {
      console.log('Vote error', error)
    })
}
onMounted(() => {
  getVotesList()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(votesList.value?.options, (vote) => {
      return (_openBlock(), _createBlock(BaseButton, {
        onClick: ($event: any) => (isAuth.value && setVotes(vote.option_id)),
        key: vote.option_id,
        class: "large rounded full-width vote-btn mb-20",
        bg: "none",
        border: isVotes.value === vote.option_id ? 'selected' : 'gradient'
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_4, _toDisplayString(vote.option_name), 1),
          (!isVotes.value)
            ? (_openBlock(), _createBlock(IconBase, {
                key: 0,
                name: isAuth.value ? 'close' : 'lock',
                "view-box": "0 0 16 18",
                width: 16,
                height: 18
              }, null, 8, ["name"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(vote.percentage) + "%", 1))
        ]),
        _: 2
      }, 1032, ["onClick", "border"]))
    }), 128)),
    _createVNode(BorderText, { bg: "bg-gray" }, {
      default: _withCtx(() => [
        _hoisted_6
      ]),
      _: 1
    })
  ]))
}
}

})